import { Grid2 } from '@mui/material';
import React, { useEffect, useState } from 'react';
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { Control, FieldErrors,  UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { useComunMinvu } from '../hooks/useComunMinvu';
import InputFileUpload from "../../../../components/inputs/yup/materialui/inputFileUpload";

export interface IFilter {
    file?: File | null;
    tipoBeneficio: string;
}


export interface IProps {
    control: Control<IFilter, any>
    errors: FieldErrors<IFilter>;
    watch: UseFormWatch<IFilter>
    setValue: UseFormSetValue<IFilter>;
    limpiar?: () => void;
}

const CargarRespuestaComun: React.FC<IProps> = ({ control, errors, watch, setValue, limpiar }) => {

    const { listaBeneficios, beneficios } = useComunMinvu();
    const [inputKey, setInputKey] = useState(Date.now()); //KEY PARA INPUTFILE

    useEffect(() => {
        listaBeneficios();
        // eslint-disable-next-line
    }, []);
    const handleLimpiar = () => {
        // Implementar lógica para limpiar los filtros
        if (limpiar) {
            limpiar();
        }
        setValue("file", null);
        setValue("tipoBeneficio", "");
        setInputKey(Date.now())
    }
    return (
        <Grid2 container spacing={2} sx={{ mb: 3 }}>
            <Grid2 size={6}>
                <InputSelect
                    name="tipoBeneficio"
                    control={control}
                    error={errors?.tipoBeneficio}
                    label="Tipo de beneficio"
                    options={beneficios}
                />
            </Grid2>
            <Grid2 size={4}>
                <InputFileUpload
                    name="file"
                    control={control}
                    error={errors?.file}
                    label="Archivo.txt"
                    fileKey={inputKey}
                />
            </Grid2>
            <Grid2 size={2} sx={{ mt: 2 }}>
                <MButton onClick={() => { handleLimpiar() }} variant="contained" color="primary">
                    Limpiar
                </MButton>
            </Grid2>
        </Grid2>
    );
};

export default CargarRespuestaComun;